import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { IMAGES, LINKS, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
const autoLinks: {
  label: string;
  href: string;
}[] = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Replacement',
  href: LINKS.windshield
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}];
const mainLinks: {
  label: string;
  href: string;
}[] = [{
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}, {
  label: 'Resources',
  href: LINKS.resources
}];
export function Header() {
  const [autoOpen, setAutoOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileAutoOpen, setMobileAutoOpen] = useState(false);
  const autoWrapRef = useRef<HTMLDivElement>(null);
  const autoButtonRef = useRef<HTMLButtonElement>(null);
  const mobileButtonRef = useRef<HTMLButtonElement>(null);
  const mobilePanelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!autoOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setAutoOpen(false);
        autoButtonRef.current?.focus();
      }
    };
    const onClick = (e: MouseEvent) => {
      if (!autoWrapRef.current?.contains(e.target as Node)) setAutoOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [autoOpen]);
  useEffect(() => {
    if (!mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setMobileOpen(false);
        mobileButtonRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    const first = mobilePanelRef.current?.querySelector<HTMLElement>('a, button');
    first?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [mobileOpen]);
  const closeMobile = () => {
    setMobileOpen(false);
    setMobileAutoOpen(false);
  };
  return <header className="sticky top-0 z-50 bg-white" data-id="element-91" data-mp="1mljrgv5whr9h">
      <div className="bg-kosin-charcoal text-white" data-id="element-92" data-mp="18nbq8b1u03si">
        <div className="mx-auto flex max-w-shell items-center justify-between gap-4 px-[18px] py-2 text-[12px] sm:px-6 sm:text-[13px]" data-id="element-93" data-mp="18likcxz1lnlk">
          <p className="max-w-[20rem] text-[13px] leading-snug sm:max-w-none" data-id="element-94" data-mp="yovzwaamoyk2">
            Auto Glass, Windshield Replacement &amp; Commercial Glass in
            Southeast Michigan
          </p>
          <div className="flex items-center gap-6" data-id="element-95" data-mp="2t2x65g8icnu6">
            <p className="hidden whitespace-nowrap text-white/75 md:block" data-id="element-96" data-mp="2t487zaie7lin">Howell • Ann Arbor • Novi</p>
            <a href={PHONE_HREF} className="focus-light hidden items-center gap-2 whitespace-nowrap text-[14px] font-semibold text-white xl:inline-flex" data-id="element-97" data-mp="2y1hx0p1vdv5y">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-98" data-mp="hftljywhjizq" />
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-kosin-line" data-id="element-99" data-mp="w5sm28bij6id">
        <div className="mx-auto flex max-w-shell items-center justify-between gap-6 px-[18px] py-3 sm:px-6 lg:py-4" data-id="element-100" data-mp="rd7w5hvq9dk4">
          <a href="#top" className="shrink-0" aria-label="Kosin’s Glass home" onClick={closeMobile} data-id="element-101" data-mp="1544lmzucxemy">
            <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[58px] w-auto lg:h-[70px]" data-id="element-102" data-mp="1f3byzn13d9a2" />
          </a>

          <nav aria-label="Main" className="hidden xl:block" data-id="element-103" data-mp="3gu6usevat8gs">
            <ul className="flex items-center gap-5 whitespace-nowrap text-[14px] font-medium text-kosin-ink" data-id="element-104" data-mp="3gwjmhjquyx71">
              <li data-id="element-105" data-mp="22ynovw0t3dj1">
                <a className="hover:text-kosin-red transition-colors duration-150 ease-kosin" href="#top" data-id="element-106" data-mp="22z6vwhox4hia">
                  Home
                </a>
              </li>
              <li className="relative" ref={autoWrapRef} data-id="element-107" data-mp="27zl3xzqirrgb">
                <button ref={autoButtonRef} type="button" className="flex items-center gap-1 hover:text-kosin-red transition-colors duration-150 ease-kosin" aria-expanded={autoOpen} aria-haspopup="true" onClick={() => setAutoOpen(v => !v)} data-id="element-108" data-mp="2cy6644pc0l7e">
                  Auto Glass
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-kosin ${autoOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-109" data-mp="1t82gjgvbyumx" />
                </button>
                {autoOpen && <ul className="absolute left-0 top-full z-50 mt-3 w-[264px] border border-kosin-line bg-white py-2 shadow-[0_12px_28px_rgba(22,22,22,0.12)]" data-id="element-110" data-mp="15hqbqevdte0k">
                    {autoLinks.map(link => <li key={link.label} data-id="element-111" data-mp="t1gy8g9l6mn1">
                        <a href={link.href} className="block px-4 py-2.5 text-[14px] text-kosin-ink hover:bg-kosin-mist hover:text-kosin-red transition-colors duration-150 ease-kosin" onClick={() => setAutoOpen(false)} data-id="element-112" data-mp="oykhyw7ir2m9">
                          {link.label}
                        </a>
                      </li>)}
                  </ul>}
              </li>
              {mainLinks.map(link => <li key={link.label} data-id="element-113" data-mp="1b2moqp1pmej">
                  <a href={link.href} className="hover:text-kosin-red transition-colors duration-150 ease-kosin" data-id="element-114" data-mp="3sfsxvaiorsec">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-3" data-id="element-115" data-mp="3is6vm6y6ah5d">
            <a href={PHONE_HREF} className="hidden items-center gap-2 whitespace-nowrap text-[16px] font-semibold text-kosin-charcoal hover:text-kosin-red transition-colors duration-150 ease-kosin sm:flex xl:hidden" data-id="element-116" data-mp="3isyech6o8ke8">
              <PhoneIcon className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-117" data-mp="eh73967aquf" />
              {PHONE_DISPLAY}
            </a>
            <a href="#quote" className="hidden whitespace-nowrap rounded bg-kosin-red px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-kosin-bright transition-colors duration-150 ease-kosin lg:inline-block" data-id="element-118" data-mp="5c8vvubjtwue">
              Get a free quote
            </a>
            <a href={PHONE_HREF} aria-label={`Call ${PHONE_DISPLAY}`} title={`Call ${PHONE_DISPLAY}`} className="flex h-11 w-11 items-center justify-center text-kosin-red sm:hidden" data-id="element-119" data-mp="jc0fqboqy7gb">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-120" data-mp="28tf8ux4zpz9e" />
            </a>
            <button ref={mobileButtonRef} type="button" className="flex h-11 w-11 items-center justify-center rounded border border-kosin-line text-kosin-charcoal xl:hidden" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} title={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} aria-controls="mobile-menu" onClick={() => mobileOpen ? closeMobile() : setMobileOpen(true)} data-id="element-121" data-mp="23vdo87rx1rvt">
              {mobileOpen ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="1yxc7vulvk6o1" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="1utmnlhc8gb8t" />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && <div id="mobile-menu" ref={mobilePanelRef} className="max-h-[calc(100dvh-160px)] overflow-y-auto overscroll-contain border-b border-kosin-line bg-white xl:hidden" data-id="element-124" data-mp="36a48ck6gwpfm">
          <nav aria-label="Mobile" className="mx-auto max-w-shell px-[18px] py-4 sm:px-6" data-id="element-125" data-mp="18l7hc6sd2yf1">
            <ul className="divide-y divide-kosin-line text-[16px] font-medium text-kosin-ink" data-id="element-126" data-mp="1dktru8gt20k5">
              <li data-id="element-127" data-mp="1icbv536awd8a">
                <a href="#top" className="block py-3" onClick={closeMobile} data-id="element-128" data-mp="1icv968styhh1">
                  Home
                </a>
              </li>
              <li data-id="element-129" data-mp="1mfhvxvan9c7d">
                <button type="button" className="flex w-full items-center justify-between py-3" aria-expanded={mobileAutoOpen} onClick={() => setMobileAutoOpen(v => !v)} data-id="element-130" data-mp="1rci5wham6z3r">
                  Auto Glass
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-kosin ${mobileAutoOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-131" data-mp="1xjzmhduypur" />
                </button>
                {mobileAutoOpen && <ul className="pb-3 pl-3" data-id="element-132" data-mp="2ffohomz6g9uc">
                    {autoLinks.map(link => <li key={link.label} data-id="element-133" data-mp="2be37xahxwbod">
                        <a href={link.href} className="block py-2 text-[15px] font-normal text-kosin-body" onClick={closeMobile} data-id="element-134" data-mp="2beuqnkqfuex8">
                          {link.label}
                        </a>
                      </li>)}
                  </ul>}
              </li>
              {mainLinks.map(link => <li key={link.label} data-id="element-135" data-mp="2p69j0i68jsgy">
                  <a href={link.href} className="block py-3" onClick={closeMobile} data-id="element-136" data-mp="2p580xtqsy5pq">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-4 flex flex-col gap-2" data-id="element-137" data-mp="1dq2tkcfq7izs">
              <a href="#quote" className="rounded bg-kosin-red px-5 py-3 text-center text-[15px] font-semibold text-white" onClick={closeMobile} data-id="element-138" data-mp="1d2xi9m68mmej">
                Get a free quote
              </a>
              <a href={PHONE_HREF} className="flex items-center justify-center gap-2 rounded border border-kosin-line px-5 py-3 text-[15px] font-semibold text-kosin-charcoal" onClick={closeMobile} data-id="element-139" data-mp="1muaa4ds1dckk">
                <PhoneIcon className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-140" data-mp="1qv3w31lx4hat" />
                Call {PHONE_DISPLAY}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}